import { rem } from 'polished';
import styled from 'styled-components';

export const StyledWrapper = styled.div`
  width: 100%;
  background-color: ${({ theme }) => theme.colors.cross.ultralightGray};

  @media screen and (max-width: ${({ theme }) => theme.breakpoints.l}) {
    padding-bottom: ${({ theme }) => rem(theme.spacings.s)};
  }

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.l}) {
    padding: ${({ theme }) => rem(theme.spacings.s)};
    border-radius: ${({ theme }) => rem(theme.spacings.s)};
  }
`;
